var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMicrophone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9 16.5583c0 4.0544 2.5358 6.8988 6.2612 7.2298v1.6805l.0022.7958c.0011.4066.3311.7356.7377.7356.4074 0 .7377-.3303.7377-.7377v-.7937-1.6805c3.7379-.331 6.2612-3.1754 6.2612-7.2298v-1.0996c0-.4343-.3224-.7758-.7325-.7758-.4133 0-.7451.3415-.7451.7758v1.0374c0 3.5269-2.1727 5.8645-5.5161 5.8645-3.356 0-5.5287-2.3376-5.5287-5.8645v-1.0374c0-.4343-.3224-.7758-.74192-.7758-.41324 0-.73568.3415-.73568.7758z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.0077 21c2.3877 0 3.9923-1.6289 3.9923-3.9575v-8.0847c0-2.33976-1.6046-3.9578-3.9923-3.9578-2.3992 0-4.0077 1.61804-4.0077 3.9578v8.0847c0 2.3286 1.6085 3.9575 4.0077 3.9575z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophone);
export default __webpack_public_path__ + "static/media/Microphone.3adef38b7e97a787fd7861ca0c57c6e9.svg";
export { ForwardRef as ReactComponent };